










































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import MonitoringKritisIgdKpiHeader from "./MonitoringKritisIgdKpiHeader.vue";
import MonitoringKritisIgdTtvTimeline from "./MonitoringKritisIgdTtvTimeline.vue";
import MonitoringKritisIgdActionTimeline from "./MonitoringKritisIgdActionTimeline.vue";
import MonitoringKritisIgdDisposisi from "./MonitoringKritisIgdDisposisi.vue";
import MonitoringKritisIgdSvc from "@/services/MonitoringKritisIgdService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    PersonAutoComplete,
    MonitoringKritisIgdKpiHeader,
    MonitoringKritisIgdTtvTimeline,
    MonitoringKritisIgdActionTimeline,
    MonitoringKritisIgdDisposisi,
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class MonitoringKritisIgdDetail extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) monitoringData!: any;
  @Prop({ default: false }) readonly!: boolean;

  isReadOnly!: () => boolean;
  get editWindowReadOnly(): boolean {
    return this.isReadOnly();
  }

  openPanels: number[] = [0, 1];
  monitoring: any = null;

  saving = false;
  formValid = false;
  autoSaveTimeout: any = null;
  editFormForId: any = null;

  form: any = {
    register_id: "",
    pasien_rm: "",
    unit_id: "",
    dokter_igd_user_id: null,
    perawat_pj_user_id: null,
    dpjp_konsultan_user_id: null,
  };

  editForm: any = { resuscitation_targets: {} };

  mounted() {
    this.form.register_id = this.register;
    this.form.pasien_rm = this.rm;
    this.form.unit_id = userModule.user?.unit_id || "";
    this.form.dokter_igd_user_id = userModule.user?.id || null;

    if (this.monitoringData) {
      this.monitoring = this.monitoringData;
      this.syncEditForm();
      if (this.monitoringData.id) {
        this.refreshData(this.monitoringData.id);
      }
    }
  }

  beforeDestroy() {
    clearTimeout(this.autoSaveTimeout);
  }

  get isNew() {
    return !this.monitoringData;
  }

  // Parent replaces the object on every refresh; rebuild editForm only when the
  // record identity changes so in-flight edits survive a same-id refresh.
  @Watch("monitoring")
  onMonitoringChanged() {
    this.syncEditForm();
  }

  syncEditForm() {
    if (!this.monitoring || this.editFormForId === this.monitoring.id) return;
    this.editFormForId = this.monitoring.id;
    this.editForm = JSON.parse(JSON.stringify({
      tanggal: this.monitoring.tanggal,
      dokter_igd_user_id: this.monitoring.dokter_igd_user_id,
      perawat_pj_user_id: this.monitoring.perawat_pj_user_id,
      dpjp_konsultan_user_id: this.monitoring.dpjp_konsultan_user_id,
      dokter_response_at: this.monitoring.dokter_response_at,
      resuscitation_targets: this.monitoring.resuscitation_targets || { target_map: 65, target_spo2: 94 },
    }));
  }

  async simpan() {
    if (this.editWindowReadOnly) return;
    if (!(this.$refs.form as any).validate()) return;
    this.saving = true;
    try {
      const resp = await MonitoringKritisIgdSvc.create(this.form);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Monitoring berhasil dibuat");
        this.monitoring = resp.data.data;
        this.syncEditForm();
      }
    } catch {
      // handled by service
    }
    this.saving = false;
  }

  autoSave() {
    if (this.readonly || this.editWindowReadOnly || !this.monitoring?.id || this.monitoring.is_locked) return;
    clearTimeout(this.autoSaveTimeout);
    this.autoSaveTimeout = setTimeout(async () => {
      try {
        await MonitoringKritisIgdSvc.update(this.monitoring.id, this.editForm);
      } catch {
        // handled by service
      }
    }, 1000);
  }

  async refreshData(id: number) {
    try {
      const resp = await MonitoringKritisIgdSvc.find(id);
      if (resp?.data?.status == "1") {
        this.monitoring = resp.data.data;
      }
    } catch {
      // handled by service
    }
  }

  async onSaved(data?: any) {
    if (data?.id) {
      await this.refreshData(data.id);
    } else if (this.monitoring?.id) {
      await this.refreshData(this.monitoring.id);
    }
    this.$emit("saved");
  }

  // Sub-table saves (TTV / intervensi-medikasi / survey edit): refresh the
  // detail in place and DON'T bubble to the list, which would pop back to the
  // list view. Only finalizing disposisi keeps the bubbling onSaved.
  async onLocalSaved(data?: any) {
    const id = data?.id || this.monitoring?.id;
    if (id) {
      await this.refreshData(id);
    }
  }

  cetakPdf() {
    if (this.monitoring?.id) {
      MonitoringKritisIgdSvc.printPdf(this.monitoring.id);
    }
  }
}
